import OverlayTips from "../OverlayTips";

function ViewTTPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

ViewTTPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    init: function()
    {
        PageOverlayTipsManager.prototype.init.call(this);

        var self = this;
        $(document).on("viewTT.init viewTT.detailsTable.update viewTT.balanceViewer.hide viewTT.balanceViewer.update",
                       function()
                       {
                           self.refreshDynamicTips();
                       });

        return this;
    },

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);


        this.add(function()
                 {
                     var balanceViewer = $(".balancesViewer");
                     var isPTO = balanceViewer.is(".showPTO");
                     var isSick = balanceViewer.is(".showSick");
                     var isAll = isPTO && isSick;
                     var balanceViewerMessage = isAll ? "view_tt.tips.balance_viewer.all" :
                                                isPTO ? "view_tt.tips.balance_viewer.PTO" :
                                                isSick ? "view_tt.tips.balance_viewer.sick" :
                                                "view_tt.tips.balance_viewer.all";
                     return {
                         // if no one from .showPTO and showSick is added then viewer not displayed
                         element: $(".balancesViewer.showPTO, .balancesViewer.showSick"),
                         config: {
                             messageKey: balanceViewerMessage,
                             direction: OverlayTips.DIRECTION_TOP_RIGHT,
                             offsetX: -10,
                             offsetY: -10
                         }
                     }
                 });


        this.add(function() { return $(".viewTTFilterPanel .commonVisibleFilterButton") }, {
            messageKey: "view_tt.tips.filter",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: 10
        });

        this.add(function() { return $("#totalsAll") }, {
            messageKey: "view_tt.tips.total_schedule",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: 5,
            offsetY: -15
        });


        this.add(function()
                 {
                     var totalMessage = $("#totalsLeave").is(".withLeaveTime") ? "view_tt.tips.total" : "view_tt.tips.total.leaves_disabled";
                     return {
                         element: $("#totalsSpent"),
                         config: {
                             messageKey: totalMessage,
                             direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                             offsetX: 0,
                             offsetY: -5,
                             outside: {
                                 direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                                 offsetX: -20,
                                 offsetY: 25
                             }
                         }
                     }
                 });

        this.add(function() { return $(".viewByLabel") }, {
            messageKey: "view_tt.tips.grouping",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 120,
            offsetY: 5
        });

        this.add(function() { return $(".showTasksContainer input") }, {
            messageKey: "view_tt.tips.show_tasks",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: 5
        });

        this.add(function() { return $(".viewByDays .dayRow").eqOrLast(0).find(".dateColumn .subContainer span") }, {
            messageKey: "view_tt.tips.day_row",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: 10,
            offsetY: 0,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: 10,
                offsetY: -10
            }
        });

        this.add(function() { return $(".viewByDays .dayRows .taskRow").eqOrLast(1).find(".nameColumn .name") }, {
            messageKey: "view_tt.tips.task_row",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: 10,
            offsetY: 0,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -30,
                offsetY: 5
            }
        });

        this.add(function() { return $(".viewByCP .cpRows .taskRow").eqOrLast(1).find(".nameColumn") }, {
            messageKey: "view_tt.tips.task_row",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: -100,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -100,
                offsetY: -15
            }
        });

        this.add(function() { return $(".viewByDays .dayRows .taskRow").eqOrLast(1).find(".detailsColumn") }, {
            messageKey: "view_tt.tips.comments",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -10,
            offsetY: -10
        });
    }
});

export default ViewTTPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/ViewTTPageOverlayTipsManager.js